// extracted by mini-css-extract-plugin
export default {"not_found":"NotFoundPage_not_found__o11l1"};